import { render, staticRenderFns } from "./RecordFeeEditBasedata.vue?vue&type=template&id=d7888710"
import script from "./RecordFeeEditBasedata.vue?vue&type=script&lang=js"
export * from "./RecordFeeEditBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports